import { US, GH, NG, TG, BJ, CI, SN, LR, SL, GN } from 'country-flag-icons/react/3x2';

const FLAGS = { US, GH, NG, TG, BJ, CI, SN, LR, SL, GN };

export const CountryFlag = ({ code, className = 'w-4 h-3' }) => {
  const Flag = FLAGS[code];
  if (!Flag) return null;
  return <Flag className={`${className} rounded-[2px] shrink-0 object-cover`} />;
};
